import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { defaultEditFormState } from "../../constant";
import { MembershipAPI } from "../../../api/membership";
import { IconButton, Stack, useMediaQuery } from "@mui/material";
import VisibilityIcon from "../../../assets/SVGs/Login/VisibilityIcon";
import { DataGrid } from "@mui/x-data-grid";
import EditReferralModal from "../../Modal/EditReferralModal";
import dayjs from "dayjs";

const ReferralSentTab = ({ id }) => {
  const navigate = useNavigate();
  const isMobileTable = useMediaQuery("(max-width:850px)");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [openEditModal, setOpenEditModal] = useState(defaultEditFormState);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      setData(await MembershipAPI.getReferral(id, "sent"));
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    isLoading && fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, isLoading]);

  const columns = [
    {
      field: "referral_name",
      headerName: "Referral Name",
      flex: 1,
      minWidth: isMobileTable ? 200 : undefined,
    },
    {
      field: "referral_date",
      headerName: "Referral Date",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate(); // returns a native JS Date
      },
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("MM/DD/YYYY") : "";
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          aria-label="view"
          size="small"
          onClick={() =>
            setOpenEditModal({
              open: true,
              id: params?.row?.id,
              title: params?.row?.referral_name,
            })
          }
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </IconButton>
      ),
    },
  ];

  return (
    <Stack
      sx={{
        width: "100%",
        "& .MuiDataGrid-root": {
          borderRadius: "8px",
        },
      }}
      className="customDataGridFigma"
    >
      <DataGrid
        rows={data?.items || []}
        columns={columns}
        loading={isLoading}
        initialState={{
          pagination: { paginationModel: { pageSize: 10 } },
        }}
        checkboxSelection={false}
        rowSelection={false}
        rowHeight={48}
        columnHeaderHeight={40}
        getRowClassName={(params) => {
          const customClassName =
            params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
          return ` ${customClassName}`.trim();
        }}
        slotProps={{
          loadingOverlay: {
            variant: "linear-progress",
            noRowsVariant: "linear-progress",
          },
        }}
        localeText={{
          noRowsLabel: "No Referrals found.",
        }}
        disableVirtualization
      />
      {openEditModal?.open && (
        <EditReferralModal
          open={openEditModal?.open}
          id={openEditModal?.id}
          handleClose={() => setOpenEditModal(defaultEditFormState)}
          setIsLoading={setIsLoading}
          title={openEditModal?.title}
        />
      )}
    </Stack>
  );
};

export default ReferralSentTab;
